//
// Memoized version of indexBy. See: lib/indexBy.jsx
//
export const useIndexBy = (xs, keyFn) => React.useMemo(() => indexBy(xs, keyFn), [xs])
